var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBizzBigLessWhiteSpace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 24,
    viewBox: "0 0 36 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.6565 19.7869C34.5281 21.2925 33.3382 22.4763 31.8535 22.5718C29.0375 22.7528 24.0853 23 18.0378 23C11.9964 23 7.04793 22.7534 4.23054 22.5723C2.75134 22.4772 1.56263 21.3022 1.4289 19.8026C1.23489 17.6283 1 14.4918 1 12.0529C1 9.60093 1.23747 6.40678 1.43208 4.20108C1.56445 2.7 2.75347 1.52262 4.23403 1.42754C7.05203 1.24662 11.9989 1 18.0378 1C24.0824 1 29.0329 1.24708 31.8496 1.428C33.3339 1.52354 34.5254 2.70662 34.6526 4.21185C34.8174 6.16216 35 9.01108 35 12.0529C35 15.0703 34.8202 17.8665 34.6565 19.7869H34.6565Z",
    stroke: "#193232",
    strokeWidth: 1.5,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0236 10.9509C26.8177 10.9509 24.2188 8.35197 24.2188 5.146",
    stroke: "#193232",
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0243 14.2679C24.9863 14.2679 20.9023 10.184 20.9023 5.146",
    stroke: "#193232",
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.024 17.585C23.154 17.585 17.585 12.0158 17.585 5.146",
    stroke: "#193232",
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBizzBigLessWhiteSpace);
export default __webpack_public_path__ + "static/media/bizz-big-less-white-space.8a572f8a99ac3f0cb74311b11dd22c5b.svg";
export { ForwardRef as ReactComponent };